import { openLoader, closeLoader } from '../loader';
import { openErrorModal } from '../modals';
import { openOverlay } from '../overlay';
import { signOut } from '../../actions/auth/userToken';
import { store } from '../../index';
import Maintenance from 'components/maintenance';

export function generateSearchQuery(data) {
  data = data ? data : {};
  const queries = Object.keys(data).filter(k => {
    return data[k];
  });
  let query = '?';

  queries.forEach((key, i) => {
    if (i !== 0) query += '&';
    query += `${key}=${data[key]}`;
  });
  return query.length > 1 ? query : '';
}

export async function handleRequest({
  request,
  actionType,
  hideLoader,
  noError,
  customLoader,
  bucket,
  overwrite,
  onError
}) {
  if (!hideLoader) {
    store.dispatch(openLoader(customLoader));
  }

  try {
    const response = await request;
    if (!hideLoader) {
      store.dispatch(closeLoader(customLoader));
    }
    store.dispatch({
      type: actionType,
      payload: response.data,
      bucket,
      overwrite
    });
    return Promise.resolve(response.data);
  } catch (err) {
    if (!hideLoader) {
      store.dispatch(closeLoader(customLoader));
    }
    if (onError) {
      onError();
    }
    if (err.config && !noError) {
      handleError(err);
    } else {
      console.error(err);
    }
    return Promise.reject(err);
  }
}

export function handleError(err) {
  if (!err.response) {
    store.dispatch(
      openErrorModal({
        title: 'Network Error',
        text: 'Please check your internet connection and then refresh the page.'
      })
    );
  } else if (err.response.status === 401) {
    signOut();
  } else if (err.response.status === 503) {
    store.dispatch(
      openOverlay({
        component: Maintenance
      })
    );
  } else if (
    err.response.data &&
    err.response.data.error &&
    err.response.data.error.message
  ) {
    store.dispatch(openErrorModal({ text: err.response.data.error.message }));
  } else {
    store.dispatch(
      openErrorModal({
        title: 'Well, this is embarassing...',
        text:
          'An unexpected error occurred. Try refreshing the page or contact us if the problem persists.'
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/actions/util/requestUtils.js